import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { useTranslation } from "../../i18n";

function AboutCard() {
  const { t } = useTranslation();
  const activities = t("aboutCard.activities");

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify", whiteSpace: "pre-line" }}>
            {t("aboutCard.body")}
          </p>
          <ul>
            {Array.isArray(activities) &&
              activities.map((activity) => (
                <li className="about-activity" key={activity}>
                  <ImPointRight /> {activity}
                </li>
              ))}
          </ul>
          <p style={{ color: "rgb(155 126 172)" }}>
            "{t("aboutCard.quote")}"
          </p>
          <footer className="blockquote-footer">Lokesh</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
